/**
 * @file Automatically generated by barrelsby.
 */

export * from './get-environment-info';
